<template>
  <p
    :class="`text-center text-[12px] font-medium rounded-full px-[10px] py-[2px] mb-0`"
    :style="{ backgroundColor: statusText.color.sub, color: statusText.color.main }"
  >{{ statusText.label }}</p>
</template>

<script>
import { statusMapping } from './config'

export default {
  name: 'StatusPackingPill',
  props: {
    status: {
      type: String,
      default: 'unknown',
    },
  },
  computed: {
    statusText() {
      const status = statusMapping[this.status]

      if (status) {
        return status
      }

      // Fallback ke status default yang valid di statusMapping
      return statusMapping.unknown
    },
  },
}
</script>
